import { Aco, LineOfBusiness, MembershipCategory } from 'scripts/api/profile/profile.interfaces';
import CONFIG from '../constants/config';
import { ILineOfBusiness, ILineOfBusinessBrands } from './population.interfaces';

export interface IPopulationPaths {
  [lineOfBusiness: string]: ILineOfBusiness;
}

export interface IBrands {
  [lineOfBusiness: string]: ILineOfBusinessBrands;
}

export const DEFAULT_LINE_OF_BUSINESS: LineOfBusiness = LineOfBusiness.EI;
export const DEFAULT_MEMBERSHIP_CATEGORY: MembershipCategory = 'DEFAULT' as MembershipCategory;
export const DEFAULT_BRAND = {
  LOGO_URL: '/images/branding/unitedhealth.svg',
  LOGO_ALT: 'United Healthcare',
};

export const POPULATION_PATHS: IPopulationPaths = {
  [LineOfBusiness.EI]: {
    DEFAULT: '',
    [MembershipCategory.EMPIRE]: '',
    [MembershipCategory.EXCHANGE]: '',
    [MembershipCategory.PUBLIC_EXCHANGE]: '',
    [MembershipCategory.EXPATRIATE]: '',
    [MembershipCategory.JPMC]: '',
    [MembershipCategory.OXFORD]: '',
    [MembershipCategory.SMALL_BUSINESS]: '',
    [MembershipCategory.UHC_MEDICA]: '',
    [MembershipCategory.UHC_WEST]: '',
  },
  [LineOfBusiness.MR]: {
    DEFAULT: '/medicare',
    [MembershipCategory.AARP]: '/aarp',
    [MembershipCategory.MEDICA]: '/medica',
    [MembershipCategory.PCP]: '/pcp',
    [MembershipCategory.RETIREE]: '/retiree',
    [MembershipCategory.TEXAS_ERS]: '/medicare',
    [MembershipCategory.UHC]: '/medicare',
  },
  [LineOfBusiness.CS]: {
    DEFAULT: '/community',
  },
};

export const BRANDS: IBrands = {
  [LineOfBusiness.EI]: {
    DEFAULT: DEFAULT_BRAND,
    [MembershipCategory.OXFORD]: {
      LOGO_URL: '/images/branding/uhc-oxford-logo.svg',
      LOGO_ALT: 'United Healthcare Oxford',
    },
    [MembershipCategory.EXPATRIATE]: {
      LOGO_URL: '/images/branding/uhc-global.svg',
      LOGO_ALT: 'United Healthcare Global',
    },
    [MembershipCategory.UHC_MEDICA]: {
      ...DEFAULT_BRAND,
      MOBILE_LOGO_URL: '/images/branding/unitedhealth-small.svg',
      SECONDARY_LOGO_URL: '/images/branding/medica.svg',
      SECONDARY_LOGO_ALT: 'Medica',
    },
    [Aco.CDP]: {
      ...DEFAULT_BRAND,
      MOBILE_LOGO_URL: '/images/branding/unitedhealth-small.svg',
      SECONDARY_LOGO_URL: '/images/branding/cdp.svg',
      SECONDARY_LOGO_ALT: 'Centura Health',
    },
  },
  [LineOfBusiness.MR]: {
    DEFAULT: DEFAULT_BRAND,
    [MembershipCategory.AARP]: {
      LOGO_URL: '/images/branding/aarp.svg',
      LOGO_ALT: 'AARP: Medicare Plans from United Healthcare',
    },
    [MembershipCategory.MEDICA]: {
      LOGO_URL: '/images/branding/medicahealthcare.svg',
      LOGO_ALT: 'Medica Healthcare',
    },
    [MembershipCategory.PCP]: {
      LOGO_URL: '/images/branding/preferredcare.svg',
      LOGO_ALT: 'Preferred Care Partners',
    },
    [MembershipCategory.TEXAS_ERS]: {
      LOGO_URL: '/images/branding/ers.svg',
      LOGO_ALT: 'Health Select Medicare RX of Texas',
      LOGO_HREF: 'http://ers.texas.gov',
    },
  },
  [LineOfBusiness.CS]: {
    DEFAULT: {
      LOGO_URL: '/images/branding/uhc-cs.svg',
      LOGO_ALT: 'United Healthcare Community Plan',
    },
  },
};

export function createMapFromWhitelist(whitelist: string): { [key: string]: boolean } {
  const whiteMap = {};
  if (whitelist) {
    whitelist.split(',').forEach(hostname => {
      whiteMap[hostname] = true;
    });
  }
  return whiteMap;
}

export const SAME_TAB_PROMO_LINKS = createMapFromWhitelist(CONFIG.ARCADE_WEB_SAME_TAB_PROMO_LINKS);
export const MR_WHITE_MAP_LINKS = createMapFromWhitelist(CONFIG.ARCADE_WEB_MR_WHITELIST_LINKS);
export const CS_WHITE_MAP_LINKS = createMapFromWhitelist(CONFIG.ARCADE_WEB_CS_WHITELIST_LINKS);
